const ssrReplaceText = (text, { search, replace }) => {
  const countWord = (text || "").split(search).length;
  for (let i = 0; i < countWord; i++) {
    text = (text || "").replace(search, replace);
  }
  return text
}
export default ssrReplaceText
